module.exports = __webpack_public_path__ + "/bundle/asset/admission2-1-2a05ed43328fb359ce94c58de7216d84.png";